import Notification from './components/Default';
import SelfServiceAnswered from './components/SelfServiceAnswered';

const Library = {
  /**
   * How override the notification template
   *    Notification settings is computed by a groupName and an event name
   *    example: CONVERSATION_CREATED is the computation of CONVERSATION AND CREATED
   *
   *  To override all CONVERSATION_CREATED notification add an entry in the library
   *    { CONVERSATION_CREATED : SpecificComponent }
   *  To override all CONVERSATION notification you can add
   *    { CONVERSATION : SpecificComponent }
   */
  SELF_SERVICE_ANSWERED: SelfServiceAnswered,
};

/**
 * @param {import('modules/notifications/types').Notification} notification
 * @returns {React.FC<import('modules/notifications/types').Notification>}
 */
export const getComponent = ({ eventType }) => {
  const [group] = eventType.replace('_', '.').split('.');
  return Library[eventType] ?? Library[group] ?? Notification;
};
